<div class="dash" *ngIf="!isLoading">
  <!-- Header strip -->
  <div class="dash-header">
    <div class="dash-header-inner">
      <div>
        <p class="dash-greeting">{{ greeting }},</p>
        <h1 class="dash-name">{{ userName }}</h1>
      </div>
      <div class="dash-header-actions">
        <a routerLink="/api-docs" class="btn btn-secondary btn-sm">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
          API docs
        </a>
        <a routerLink="/submit" class="btn btn-primary btn-sm">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Submit URLs
        </a>
      </div>
    </div>
  </div>

  <!-- Metrics row -->
  <div class="metrics-row">
    <div class="metric-card">
      <div class="metric-label">Available credits</div>
      <div class="metric-value mono">{{ animCredits }}</div>
      <a routerLink="/pricing" class="metric-link">Top up →</a>
    </div>

    <div class="metric-card">
      <div class="metric-label">Total indexed</div>
      <div class="metric-value mono">{{ animTotal }}</div>
      <div class="metric-trend positive">
        <span class="status-dot live"></span>
        <span>All time</span>
      </div>
    </div>

    <div class="metric-card">
      <div class="metric-label">Index success rate</div>
      <div class="metric-value mono">{{ successRate }}<small>%</small></div>
      <div class="metric-bar">
        <div class="metric-bar-fill" [style.width.%]="successRate"></div>
      </div>
    </div>

    <div class="metric-card">
      <div class="metric-label">This week</div>
      <div class="metric-value mono">{{ weeklyLinks }}</div>
      <svg class="sparkline" viewBox="0 0 120 32" preserveAspectRatio="none">
        <path [attr.d]="sparklinePath()" fill="none" stroke="var(--accent-glow)" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </div>
  </div>

  <!-- Status breakdown -->
  <div class="status-row">
    <div class="status-item status-success">
      <div class="status-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
      </div>
      <div>
        <div class="status-value mono">{{ submitted }}</div>
        <div class="status-label">Indexed</div>
      </div>
    </div>
    <div class="status-item status-pending">
      <div class="status-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
      </div>
      <div>
        <div class="status-value mono">{{ pending }}</div>
        <div class="status-label">In queue</div>
      </div>
    </div>
    <div class="status-item status-error">
      <div class="status-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
      </div>
      <div>
        <div class="status-value mono">{{ rejected }}</div>
        <div class="status-label">Failed</div>
      </div>
    </div>
  </div>

  <!-- Main grid -->
  <div class="dash-grid">
    <!-- API Key card -->
    <div class="dash-card api-key-card">
      <div class="card-header">
        <div>
          <h3 class="card-title">API Key</h3>
          <p class="card-subtitle">Use this key to integrate with our REST API</p>
        </div>
        <a routerLink="/api-docs" class="btn btn-ghost btn-sm">
          Docs
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="7" y1="17" x2="17" y2="7"/><polyline points="7 7 17 7 17 17"/></svg>
        </a>
      </div>
      <div class="api-key-display">
        <code class="api-key-value mono">{{ displayedKey }}</code>
        <div class="api-key-actions" *ngIf="hasApiKey">
          <button class="btn btn-icon btn-ghost" (click)="toggleKeyReveal()" [title]="apiKeyRevealed ? 'Hide' : 'Reveal'">
            <svg *ngIf="!apiKeyRevealed" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            <svg *ngIf="apiKeyRevealed" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
          </button>
          <button class="btn btn-icon btn-ghost" [class.copied]="copySuccess" (click)="copyKey()" title="Copy">
            <svg *ngIf="!copySuccess" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
            <svg *ngIf="copySuccess" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--accent-success)" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
          </button>
        </div>
      </div>
      <div class="api-key-buttons">
        <button class="btn btn-primary btn-sm" (click)="generateKey()" [disabled]="apiKeyLoading">
          <span class="spinner spinner-sm" *ngIf="apiKeyLoading"></span>
          <span>{{ hasApiKey ? 'Regenerate key' : 'Generate API key' }}</span>
        </button>
        <button class="btn btn-danger btn-sm" (click)="revokeKey()" *ngIf="hasApiKey" [disabled]="apiKeyLoading">
          Revoke
        </button>
      </div>
      <div class="api-key-toast" *ngIf="toastMsg" [class.t-ok]="toastType === 'ok'" [class.t-err]="toastType === 'err'">
        {{ toastMsg }}
      </div>
    </div>

    <!-- Recent activity card -->
    <div class="dash-card activity-card">
      <div class="card-header">
        <div>
          <h3 class="card-title">Recent activity</h3>
          <p class="card-subtitle">Latest URL submissions and their status</p>
        </div>
        <a routerLink="/history" class="btn btn-ghost btn-sm" *ngIf="recentLinks.length > 0">
          View all
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
        </a>
      </div>
      <div class="activity-list" *ngIf="recentLinks.length > 0">
        <div class="activity-item" *ngFor="let link of recentLinks.slice(0, 6); trackBy: trackByUrl">
          <span class="activity-dot" [style.background]="statusColor(link.status)"></span>
          <div class="activity-body">
            <a class="activity-url" (click)="openUrl(link.url)" title="{{ link.url }}">{{ truncUrl(link.url) }}</a>
            <div class="activity-meta">
              <span class="activity-status" [style.color]="statusColor(link.status)">{{ link.status }}</span>
              <span class="activity-time">{{ timeAgo(link.dateTime) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="activity-empty" *ngIf="recentLinks.length === 0">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" opacity="0.4"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
        <p>No activity yet</p>
        <a routerLink="/submit" class="btn btn-primary btn-sm">Submit your first URL</a>
      </div>
    </div>

    <!-- Health monitor -->
    <div class="dash-card health-card">
      <div class="card-header">
        <h3 class="card-title">URL health</h3>
        <span class="badge badge-success">98.2%</span>
      </div>
      <div class="health-bar">
        <div class="health-bar-ok" style="width: 98.2%;"></div>
        <div class="health-bar-warn" style="width: 1.8%;"></div>
      </div>
      <div class="health-legend">
        <span><span class="legend-dot" style="background: var(--accent-success)"></span> Active</span>
        <span><span class="legend-dot" style="background: var(--accent-warning)"></span> Redirects/Dead</span>
      </div>
    </div>

    <!-- Network status -->
    <div class="dash-card network-card">
      <div class="card-header">
        <h3 class="card-title">Network</h3>
        <span class="badge badge-success">
          <span class="status-dot live"></span>
          Online
        </span>
      </div>
      <ul class="network-list">
        <li>
          <span>Google Indexing API</span>
          <span class="badge badge-success">Connected</span>
        </li>
        <li>
          <span>Proxy nodes</span>
          <span class="badge badge-neutral">14 active</span>
        </li>
        <li>
          <span>Server load</span>
          <span class="badge badge-success">24%</span>
        </li>
        <li>
          <span>Queue depth</span>
          <span class="badge badge-neutral">{{ pending }} pending</span>
        </li>
      </ul>
    </div>

    <!-- Quick start -->
    <div class="dash-card quickstart-card">
      <div class="card-header">
        <h3 class="card-title">Quick start</h3>
      </div>
      <div class="quickstart-list">
        <a routerLink="/submit" class="quickstart-item">
          <div class="quickstart-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          </div>
          <div>
            <div class="quickstart-title">Submit your first URL</div>
            <div class="quickstart-desc">Paste a URL or upload a file</div>
          </div>
          <svg class="quickstart-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
        </a>
        <a routerLink="/api-docs" class="quickstart-item">
          <div class="quickstart-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
          </div>
          <div>
            <div class="quickstart-title">Integrate the API</div>
            <div class="quickstart-desc">Use the REST API in your stack</div>
          </div>
          <svg class="quickstart-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
        </a>
        <a routerLink="/drip-guide" class="quickstart-item">
          <div class="quickstart-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          </div>
          <div>
            <div class="quickstart-title">Try Drip Mode</div>
            <div class="quickstart-desc">Schedule submissions naturally</div>
          </div>
          <svg class="quickstart-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
        </a>
      </div>
    </div>
  </div>
</div>

<!-- Loading state -->
<div class="dash-loader" *ngIf="isLoading">
  <div class="spinner spinner-lg"></div>
  <p>Loading dashboard...</p>
</div>
